import { render, staticRenderFns } from "./LayoutsIntroSection.vue?vue&type=template&id=52ada795"
import script from "./LayoutsIntroSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsIntroSection.vue?vue&type=style&index=0&id=52ada795&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports